import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'

// Actions
import { getShopOwner, CreateSaveShopOwner, getShopList, updateShop } from '../../../actions/shopowners'
import { loginAs } from '../../../actions/auth'

// Utils
import { translation } from '../../../utils/helpers'

// Components
import Phone from './../../../shared/components/Phone'

// Elements
import Col from './../../../shared/elements/col'
import Panel from './../../../shared/elements/panel'
import LabelWrapper from './../../../shared/elements/labelWrapper'
import Text from './../../../shared/elements/text'
import Switch from './../../../shared/elements/switch'
import DropDown from './../../../shared/elements/dropDown'
import Label from './../../../shared/elements/label'
import Button from './../../../shared/elements/button'
import AddButton from './../../../shared/elements/addButton'
import RemoveButton from './../../../shared/elements/removeButton'
import Inline from './../../../shared/elements/inline'

// Styles
import './view.scss'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'edit',
      shopowner: {
        UserId: 0,
        ChainId: this.props.auth.user.ChainId,
        Active: true,
        Name: '',
        UserName: '',
        Phone: '',
        PhoneCode: this.props.phonecode,
        IsInvoicingUser: false,
        IsUnlimitedSupportActive: false,
        Shops: []
      },
      shoplist: [],
      shoplistsearch: ''
    }
    this.searchList = this.searchList.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onPhoneChange = this.onPhoneChange.bind(this)
    this.onRadioChange = this.onRadioChange.bind(this)
    this.saveAddShopOwner = this.saveAddShopOwner.bind(this)
    this.adminShop = this.adminShop.bind(this)
  }

  componentDidMount () {
    this.getShopOwner(this.props)
    this.getShopList(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.item.UserId !== this.props.item.UserId || nextProps.auth.user.ChainId !== this.props.auth.user.ChainId) {
      this.getShopOwner(nextProps) // item.UserId
      this.getShopList(nextProps) // auth.user.ChainId
    }
  }

  getShopOwner (props) {
    if (typeof props.item.UserId !== 'undefined') {
      props.getShopOwner(props.item.UserId).then((res) => {
        this.setState({
          type: 'edit',
          shopowner: res.data
        })
      })
    } else {
      this.resetCreate()
    }
  }

  getShopList (props) {
    if (typeof props.auth.user.ChainId !== 'undefined') {
      props.getShopList(props.auth.user.ChainId).then((res) => {
        this.setState({
          shoplist: res.data
        })
      })
    } else {
      this.resetCreate()
    }
  }

  resetCreate () {
    this.setState({
      type: 'create',
      shopowner: {
        UserId: 0,
        ChainId: this.props.auth.user.ChainId,
        Active: true,
        Name: '',
        UserName: '',
        Phone: '',
        PhoneCode: this.props.phonecode,
        IsInvoicingUser: false,
        IsUnlimitedSupportActive: false,
        Shops: []
      }
    })
  }

  loginAs (id, shopId, support, impersonate) {
    this.props.loginAs(id, shopId, support, impersonate).then((res) => {
      this.props.router.push('/')
    }, (err) => {
      console.log('Nooooo, could not login', err.response.data)
    })
  }

  saveAddShopOwner (e) {
    let shopowner = this.state.shopowner
     // update
    if (shopowner.UserId > 0) {
      this.props.CreateSaveShopOwner(shopowner).then((res) => {
        this.props.onSave(res.data, this.state.type)
        this.setState({
          shopowner: res.data
        })
      }, (err) => {
        if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
          let errors = err.response.data.Errors
          let errText = ''
          errors.map((item) => {
            if (item.DictionaryKey !== 0) {
              errText += '<br />' + translation(item.DictionaryKey)
            }
          })
          // Toastr
          window.toastr.error(translation(errText), translation('216'))
        } else {
          const errorMessage = (error) => {
            let messageText = ''
            if (error < 5) {
              messageText += translation('2145')
            }
            if (messageText !== '') messageText += ' '
            switch (error) {
              case 1:
                messageText += translation('16329')
                break
              case 2:
                messageText += translation('16336')
                break
              case 3:
                messageText += translation('16335')
                break
              case 4:
                messageText += translation('16338')
                break
              case 5:
                messageText += translation('16337')
                break
              default:
                break
            }
            messageText += '<br>'
            return messageText
          }
          let errors = err.response.data
          if (Array.isArray(errors)) {
            let message = errors.map(error => errorMessage(error))
            window.toastr.error(message, translation('216'))
          } else {
            window.toastr.error(translation('17954'), translation('216'))
          }
        }
      })
    }
  }

  removeShop (id) {
    this.adminShop(undefined, id)
  }

  adminShop (e, id) {
    var value = 0
    if (e === undefined) {
      value = id
    } else {
      value = e.target.value
    }
    let shopowner = this.state.shopowner
    let shop = {
      UserId: shopowner.UserId,
      ShopId: value
    }
    this.props.updateShop(shop).then((res) => {
      this.getShopOwner(this.props)
    }, () => {
      // Toastr
      window.toastr.error(translation('13465'), translation('216'))
    })
  }

  onInputChange (e) {
    e.persist()
    let name = ''
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      // if (typeof e === 'undefined') {
      //   e = name
      // }
      name = e.target.name
      value = e.target.value
    }
    this.setState({
      shopowner: {
        ...this.state.shopowner,
        [name]: value
      }
    }, () => {
      if (e.target.name === 'shops') this.adminShop()
    })
  }

  onPhoneChange (name, e) {
    let value = ''
    value = name.target.value
    if (name.target.name === 'PhoneNumber') {
      this.setState({
        shopowner: {
          ...this.state.shopowner,
          Phone: name.target.value
        }
      })
    } else {
      this.setState({
        shopowner: {
          ...this.state.shopowner,
          PhoneCode: {
            Id: Number(value.Id)
          }
        }
      }, () => { this.saveAddShopOwner() })
    }
  }

  onRadioChange (e) {
    let value = e.target.value
    let name = e.target.name
    if (e.target.type === 'radio') value = e.target.value === 'yes'
    if (e.target.type === 'checkbox') value = e.target.checked
    this.setState({
      shopowner: {
        ...this.state.shopowner,
        [name]: value
      }
    }, () => {
      this.saveAddShopOwner()
    })
  }

  searchList (e) {
    this.setState({
      shoplistsearch: e.target.value
    })
  }

  renderOwner () {
    let shopowner = this.state.shopowner
    let impersonate = true

    return (
      <Panel title={1880}>
        <Text name='Name' value={shopowner.Name || ''} onChange={this.onInputChange} onBlur={this.saveAddShopOwner} labelText={translation('30')} />
        <LabelWrapper labelText={translation('38')}>
          <Phone
            onChange={this.onPhoneChange}
            code={shopowner.PhoneCode}
            number={shopowner.Phone}
            onBlur={this.saveAddShopOwner} />
        </LabelWrapper>
        <Text name='Email' value={shopowner.Email || ''} onChange={this.onInputChange} onBlur={this.saveAddShopOwner} labelText={translation('1052')} />
        <Text name='UserName' value={shopowner.UserName || ''} onChange={this.onInputChange} onBlur={this.saveAddShopOwner} labelText={translation('1')} />
        <Switch name='Active' checked={shopowner.Active} onChange={this.onRadioChange} labelText={translation('295')} />
        {(shopowner.UserId > 0 && shopowner.CanImpersonate) && (
          <Button onClick={this.loginAs.bind(this, shopowner.UserId, 0, false, impersonate)} style='link' labelText={translation('57')} />
        )}
      </Panel>
    )
  }

  renderOwnerInvoiceSettings () {
    // 18394 = invoicing user
    // 18395 = unlimited support
    let shopowner = this.state.shopowner
    return (
      <Panel title={18393}>
        <Switch name='IsInvoicingUser' checked={shopowner.IsInvoicingUser} onChange={this.onRadioChange} labelText={18394} />
        <Switch name='IsUnlimitedSupportActive' checked={shopowner.IsUnlimitedSupportActive} onChange={this.onRadioChange} labelText={18395} />
      </Panel>
    )
  }

  renderShops () {
    let shopowner = this.state.shopowner
    const renderShops = (val, key) => {
      return (
        <Inline fillChildNum={[0]} block key={key}>
          <Label>{val.Name}</Label>
          <RemoveButton minus onClick={this.removeShop.bind(this, val.Id)} size='m' />
        </Inline>
      )
    }
    const renderShopList = (val, key) => {
      return (
        <option key={key} value={val.ShopId}>{val.ShopName}</option>
      )
    }
    return (
      <Panel title={translation('1861')}>
        {shopowner.Shops.map(renderShops)}
        <Inline fillChildNum={[0]} block>
          <DropDown name='shops' onChange={this.adminShop} value={0}>
            <option value={0}>{translation('890')} {translation('700')}</option>
            {this.state.shoplist.filter(x => x.Active).map(renderShopList)}
          </DropDown>
          <AddButton />
        </Inline>
      </Panel>
    )
  }

  render () {
    let classNameList = (this.state.type === 'edit') ? 'view_edit' : 'view_create'
    return (
      <div className={classNameList}>
        <Col>
          {this.renderOwner()}
          {this.renderOwnerInvoiceSettings()}
        </Col>
        {(this.state.shopowner.UserId > 0) && (<Col>{this.renderShops()}</Col>)}
      </div>
    )
  }

}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode,
    phonecodes: state.common.phonecodes
  }
}

export default connect(mapStateToProps, {
  getShopOwner,
  CreateSaveShopOwner,
  getShopList,
  updateShop,
  loginAs
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/ShopOwners/View/index.js